import { cn } from "../../utils/classNames";

const variants = {
  cozy: "border-hookd-empress/50 text-hookd-cream",
  bold: "border-hookd-neon/60 text-hookd-neon",
  laughs: "border-hookd-gold/60 text-hookd-gold",
  deep: "border-hookd-empress/50 text-hookd-empress",
  thrill: "border-red-400/50 text-red-300",
  wildcard: "border-hookd-gold/60 text-hookd-gold",
  filter: "border-white/10 text-hookd-cream",
};

export default function Chip({
  children,
  active = false,
  variant = "filter",
  className = "",
  as: Component = "span",
  ...props
}) {
  return (
    <Component
      className={cn(
        "inline-flex min-h-9 items-center justify-center gap-2 rounded-md border px-3 py-2 text-xs font-semibold transition",
        active
          ? "border-hookd-empress bg-hookd-purple text-white shadow-glow"
          : "bg-white/5 hover:border-hookd-empress/60 hover:bg-hookd-empress/10",
        variants[variant] || variants.filter,
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
}
